var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-box"},[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.backHome}},[_vm._v(_vm._s(_vm.$t("backhome")))]),_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.backPrev}},[_vm._v(_vm._s(_vm.$t("backpreviouspage"))+"("+_vm._s(_vm.second)+"s)")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }